import { render, staticRenderFns } from "./VideoRoomHeader.vue?vue&type=template&id=64970a5b&scoped=true"
import script from "./VideoRoomHeader.vue?vue&type=script&lang=js"
export * from "./VideoRoomHeader.vue?vue&type=script&lang=js"
import style0 from "./VideoRoomHeader.vue?vue&type=style&index=0&id=64970a5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64970a5b",
  null
  
)

export default component.exports